import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";

export default function DisclaimerBanner() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div
      data-testid="medical-disclaimer-banner"
      className="sticky top-0 z-40 w-full"
      style={{
        background: "linear-gradient(90deg, #FDF0EA 0%, #F4EFE6 100%)",
        borderBottom: "1px solid #E5DEC9",
        boxShadow: "0 4px 20px -2px rgba(217, 107, 67, 0.12)",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-start gap-3">
        <AlertTriangle
          size={18}
          className="mt-0.5 shrink-0"
          style={{ color: "#BF5832" }}
        />
        <p className="text-xs sm:text-sm leading-relaxed" style={{ color: "#5C3B2A" }}>
          <span className="font-semibold">Medical Disclaimer:</span> Harmonix Health is an
          informational AI analysis tool and does not provide medical advice, diagnosis,
          or treatment. Always consult a qualified physician or pharmacist before changing
          medications.
        </p>
        <button
          data-testid="close-disclaimer-btn"
          aria-label="Close disclaimer"
          onClick={() => setOpen(false)}
          className="shrink-0 p-1.5 rounded-full hover:bg-[#F4EFE6] transition-colors"
        >
          <X size={16} style={{ color: "#5C3B2A" }} />
        </button>
      </div>
    </div>
  );
}
